export default [
  {
    path: '/account/create',
    name: 'create',
    component: () => import('@/views/client/account/AccountCreate.vue'),
    meta: {
      layout: 'full',
      pageTitle: 'Account',
    },
  },
  {
    path: '/user/emailmismatch',
    name: 'email-mismatch',
    component: () => import('@/views/client/account/EmailMismatch.vue'),
    meta: {
      layout: 'full',
      pageTitle: 'Email Mismatch',
    },
  },
  {
    path: '/user/invitationexpired',
    name: 'invitation-expired',
    component: () => import('@/views/client/account/InvitationExpired.vue'),
    meta: {
      layout: 'full',
      pageTitle: 'Invitation Expired',
    },
  },
  {
    path: '/user/invitation',
    name: 'user-invitation',
  },
  {
    path: '/:accountId/account/balance',
    name: 'balance',
    component: () => import('@/views/client/account/balance/Balance.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Balance',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Balance',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/account/balance/deposit',
    name: 'deposit',
    component: () => import('@/views/client/account/balance/Deposit.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Balance.Deposit',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Balance',
          to: '/account/balance',
        },
        {
          text: 'ClientPortal.SideMenu.Balance.Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/account/balance/withdraw',
    name: 'withdraw',
    component: () => import('@/views/client/account/balance/Withdraw.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Balance.Withdraw',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Balance',
          to: '/account/balance',
        },
        {
          text: 'ClientPortal.SideMenu.Balance.Withdraw',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/account/settings',
    name: 'settings',
    component: () => import('@/views/client/account/Settings.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Settings',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/notifications',
    name: 'notifications',
    component: () => import('@/views/client/account/Notifications.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Notifications',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Notifications',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/subscriptions',
    name: 'subscriptions',
    component: () => import('@/views/client/account/Subscriptions.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Subscriptions',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Subscriptions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/error',
    name: 'error-page',
    component: () => import('@/@core/components/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      pageTitle: 'Error',
    },
  },
]
